import InnerComponent from '@Components/Quality/QualityChecks/ListQualityChecks';
import orgContainer from '@Components/AppContainer';

const ListQualityChecks = () => ((orgContainer(InnerComponent)));
export default ListQualityChecks;
